import { defineVuesticConfig } from "vuestic-ui";

export default defineVuesticConfig({

})